<template>
  <page-wrapper
    ref="pageEl"
    :title="'ใบแจ้งหนี้'"
    :is-invoice-list-page="true"
    @showMobileNavBar="showMobileNavBar"
  >
    <div class="partner">
      <!-- Admin -->
      <el-tabs v-if="isRuejaiPartnerAdmin" v-model="activeStatus" class="mt-4">
        <el-tab-pane
          key="in_progress"
          name="in_progress"
          label="ระหว่างตรวจสอบ"
        >
          <invoice-list :active-status="activeStatus" status="in_progress" />
        </el-tab-pane>
        <el-tab-pane key="rejected" name="rejected" label="ไม่อนุมัติ">
          <invoice-list :active-status="activeStatus" status="rejected" />
        </el-tab-pane>
        <el-tab-pane key="transferred" name="transferred" label="เสร็จสิ้น">
          <invoice-list :active-status="activeStatus" status="transferred" />
        </el-tab-pane>
      </el-tabs>

      <!-- Partner -->
      <el-tabs v-else v-model="activeStatus" class="mt-4">
        <el-tab-pane key="un_billed" name="un_billed" label="หน้าหลัก">
          <dashboard-body
            :active-status="activeStatus"
            status="un_billed"
            @onItemClick="handleDashboardItemClick"
          />
        </el-tab-pane>
        <el-tab-pane
          key="in_progress"
          name="in_progress"
          label="ระหว่างตรวจสอบ"
        >
          <invoice-list :active-status="activeStatus" status="in_progress" />
        </el-tab-pane>
        <el-tab-pane key="rejected" name="rejected" label="ไม่อนุมัติ">
          <invoice-list :active-status="activeStatus" status="rejected" />
        </el-tab-pane>
        <el-tab-pane key="transferred" name="transferred" label="เสร็จสิ้น">
          <invoice-list :active-status="activeStatus" status="transferred" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../components/SupplierPageWrapper"
import DashboardBody from "../components/InvoiceDashboardBody"
import InvoiceList from "../components/InvoiceDashboardInvoiceList"
import { permissionRole } from "../../lib/mapper"

export default {
  components: {
    PageWrapper,
    DashboardBody,
    InvoiceList,
  },
  data() {
    return {
      roleId: parseInt(localStorage.getItem("supplierRoleId"), 10),
      activeStatus: "un_billed",
    }
  },
  computed: {
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN
    },
  },
  watch: {
    "$route.query": function routeQueryWatcher() {
      this.activeStatus = this.$route.query.status || "un_billed"
    },
    activeStatus(status) {
      const { name, query: history } = this.$route
      let query

      if (history.status === status) {
        query = { ...history }
      } else {
        query = { status }
      }

      this.$router
        .replace({
          name,
          query,
        })
        .catch(() => {})
    },
  },
  created() {
    this.setDefaultActiveStatus()
  },
  methods: {
    setDefaultActiveStatus() {
      const { query } = this.$route
      const status = query.status || "un_billed"

      this.activeStatus = status
    },
    handleDashboardItemClick(status) {
      this.activeStatus = status
    },
    showMobileNavBar() {
      this.$emit("showMobileNavBar")
    },
  },
}
</script>
